import axios from "axios";
import { API_BASE_URL } from "./config";

const api = axios.create({
  baseURL: `${API_BASE_URL}/api/history`,
  withCredentials: true,
});

export const recordWatch = async (videoId, progress = 0) => {
  const response = await api.post("/", { videoId, progress });
  return response.data;
};

export const getUserHistory = async () => {
  const response = await api.get("/");
  return response.data;
};

export const getContinueWatching = async () => {
  const response = await api.get("/continue-watching");
  return response.data;
};

export const removeHistoryItem = async (id) => {
  const response = await api.delete(`/${id}`);
  return response.data;
};

export const clearHistory = async () => {
  const response = await api.delete("/clear");
  return response.data;
};
